module.exports = __webpack_public_path__ + "img/academy_products.4f1c4b5d.svg";